import React from "react";
import { Linkedin, ExternalLink } from "lucide-react";
import OmkarMore from "../../Images/Profile2.png";
import SanjayMore from "../../Images/SanjayMore.png";

const LeadershipLegacy = () => {
  return (
    <section
      id="leadership"
      className="py-20 md:py-32 px-4 sm:px-6 bg-slate-50"
    >
      <div className="max-w-6xl mx-auto">
        {/* HEADER */}

        <div className="mb-16">
          <p className="text-orange-600 text-xs font-bold uppercase tracking-widest mb-2">
            Company Leadership
          </p>

          <h2 className="text-3xl md:text-5xl font-black text-slate-900">
            Founders & Management
          </h2>

          <p className="text-slate-500 mt-3 max-w-2xl text-sm">
            Focus NDT Group is led by experienced inspection professionals and
            technology developers working in the field of Non Destructive
            Testing (NDT), inspection services, and industrial software
            solutions.
          </p>
        </div>

        {/* GRID */}

        <div className="grid md:grid-cols-2 gap-10">
          {/* SANJAY MORE */}

          <div className="bg-white shadow border border-slate-100 overflow-hidden">
            <div className="w-full h-[420px] bg-slate-50 flex items-end justify-center overflow-hidden border-b border-slate-200 p-4">
              <img
                src={SanjayMore}
                alt="Sanjay More Owner Focus Inspection Technology"
                className="h-full object-contain rounded"
                loading="lazy"
              />
            </div>

            <div className="p-6">
              <h3 className="text-2xl font-bold text-slate-900">Sanjay More</h3>

              <p className="text-xs text-slate-400 mt-1">
                Level III – UT / MT / PT
              </p>

              <p className="text-orange-600 text-sm font-semibold">
                Owner & CEO – Focus Inspection Technology / Focus NDT
                Innovations
              </p>

              <p className="text-xs text-slate-400 mt-1">
                Founder – Focus NDT Group
              </p>

              <p className="text-slate-500 text-sm mt-4 leading-relaxed">
                Sanjay More is the owner and CEO of Focus Inspection Technology
                and Focus NDT Innovations with more than 25 years of experience
                in Non Destructive Testing (NDT), ultrasonic testing, and
                industrial inspection.
              </p>

              <p className="text-slate-500 text-sm mt-3 leading-relaxed">
                He is certified Level 3 in UT, MT, and PT and has extensive
                experience in PAUT, TOFD, pipeline inspection, shutdown
                projects, and asset integrity evaluation for oil & gas,
                refinery, shipyard, and heavy engineering industries.
              </p>
            </div>
          </div>

          {/* OMKAR MORE */}

          <div className="bg-white shadow border border-slate-100 overflow-hidden">
            <div className="w-full h-[420px] bg-slate-50 flex items-end justify-center overflow-hidden border-b border-slate-200 p-4">
              <img
                src={OmkarMore}
                alt="Omkar More CTO Focus NDT Group"
                className="h-full object-contain rounded"
                loading="lazy"
              />
            </div>

            <div className="p-6">
              <h3 className="text-2xl font-bold text-slate-900">Omkar More</h3>

              <p className="text-xs text-slate-400 mt-1">
                Level II – UT / MT / PT / RT | PCN UT & PAUT | IT Engineer
              </p>

              <p className="text-orange-600 text-sm font-semibold">
                Chief Technology Officer (CTO) – Focus NDT Group
              </p>

              <p className="text-xs text-slate-400 mt-1">
                Technology Head – Focus Inspection Technology / Focus NDT
                Innovations
              </p>

              <p className="text-slate-500 text-sm mt-4 leading-relaxed">
                Omkar More is the Chief Technology Officer (CTO) of Focus NDT
                Group and leads the technology, software, and automation
                division for Focus Inspection Technology and Focus NDT
                Innovations.
              </p>

              <p className="text-slate-500 text-sm mt-3 leading-relaxed">
                He holds Level 2 certification in UT, MT, PT, and RT, and PCN
                Level 2 certification in UT and PAUT. He develops inspection
                reporting platforms, automation tools, and cloud-based systems
                used for industrial NDT data management including FocusIn360
                inspection software.
              </p>

              {/* LINKS */}

              <div className="mt-6 flex gap-4 text-sm">
                <a
                  href="https://www.linkedin.com/in/omkar-more-379984214/"
                  className="flex items-center gap-2 text-slate-500 hover:text-orange-600"
                >
                  <Linkedin size={16} />
                  LinkedIn
                </a>

                <a
                  href="https://omkarmore.com/"
                  className="flex items-center gap-2 text-slate-500 hover:text-orange-600"
                >
                  <ExternalLink size={16} />
                  Portfolio
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* TEAM STRENGTH */}

        <div className="mt-14 border-t border-slate-200 pt-10">
          <h3 className="text-xl font-bold text-slate-900 mb-6">
            Technical Team & Field Workforce
          </h3>

          <p className="text-slate-500 text-sm max-w-3xl leading-relaxed mb-8">
            Our company operates with a skilled team of certified NDT
            technicians, inspectors, and field engineers working on industrial
            inspection, ultrasonic testing, PAUT, TOFD, and shutdown projects.
            The team has experience in refinery, shipyard, offshore, pipeline,
            and heavy fabrication inspection.
          </p>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-6 text-center">
            <div>
              <p className="text-2xl font-black text-slate-900">10+</p>
              <p className="text-xs text-slate-400 uppercase">Technicians</p>
            </div>

            <div>
              <p className="text-2xl font-black text-slate-900">25+</p>
              <p className="text-xs text-slate-400 uppercase">
                Years Experience
              </p>
            </div>

            <div>
              <p className="text-2xl font-black text-slate-900">100+</p>
              <p className="text-xs text-slate-400 uppercase">Projects</p>
            </div>

            <div>
              <p className="text-2xl font-black text-slate-900">5+</p>
              <p className="text-xs text-slate-400 uppercase">Industries</p>
            </div>

            <div>
              <p className="text-2xl font-black text-slate-900">India</p>
              <p className="text-xs text-slate-400 uppercase">Operated From</p>
            </div>

            <div>
              <p className="text-2xl font-black text-slate-900">Global</p>
              <p className="text-xs text-slate-400 uppercase">Operations</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeadershipLegacy;
